export const LangString = {
  customizeLayout: 'Customize Layout',
  togglePanel: 'Toggle Panel',
  togglePrimarySideBar: 'Toggle Primary Side Bar',
  toggleSecondarySideBar: 'Toggle Secondary Side Bar',
  primarySideBar: 'Primary Side Bar',
  secondarySideBar: 'Secondary Side Bar',
  panel: 'Panel',
  alignPanel: 'Align Panel',
  menuBar: 'Menu Bar',
  activityBar: 'Activity Bar',
  statusBar: 'Status Bar',
  left: 'Left',
  right: 'Right',
  center: 'Center',
  justify: 'Justify',
  primarySideBarPosition: 'Primary Side Bar Position',
  panelAlignment: 'Panel Alignment',
  visibility: 'Visibility',
  restoreDefault: 'Restore Default',
  close: 'Close',
  hide: 'Hide',
  hidden: 'Hidden',
  show: 'Show',
  side: 'Side',
  top: 'Top',
  badge: 'Badge',
  additionalViews: 'Additional Views',
  activityBarPosition: 'Activity Bar Position',
  movePrimarySideBarRight: 'Move Primary Side Bar Right',
  movePrimarySideBarLeft: 'Move Primary Side Bar Left',
  moveSecondarySideBarRight: 'Move Secondary Side Bar Right',
  moveSecondarySideBarLeft: 'Move Secondary Side Bar Left',
  hideSecondarySideBar: 'Hide Secondary Side Bar',
  hidePanel: 'Hide Panel',
  maximizePanel: 'Maximize Panel',
  restorePanelSize: 'Restore Panel Size',
};